import { styled } from "@mui/material"

export const Row = styled("div")(() => ({
  display: "flex",
  gap: 11,
  padding: "7px 0",
}))
